<template>
    <CCard>
        <CCardBody>
            <v-toolbar flat color="white">
                <v-toolbar-title>اقلام ورودی</v-toolbar-title>
                <v-spacer></v-spacer>
                <CButton color="info" class="mb-2 ml-2 text-white"
                         @click="addItem">
                    آیتم جدید
                </CButton>
                <v-dialog v-model="dialog" max-width="500px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{formTitle}}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm12 md12>
                                        <div class="form-group">
                                            <label>نام آیتم</label>
                                            <v-text-field v-if="!editItemText"
                                                          v-model="editedItem.product_name"
                                                          @click="()=>{this.editItemText = true}"/>
                                            <v-autocomplete
                                                    v-else
                                                    v-model="editedItem.product_option_id"
                                                    :items="productsList"
                                                    :loading="productAutoLoading"
                                                    :search-input.sync="productSearch"
                                                    color="white"
                                                    hide-no-data
                                                    hide-selected
                                                    item-text="name"
                                                    item-value="product_option_id"
                                                    placeholder="مدل کالا را وارد کنید"
                                                    single-line
                                                    no-filter
                                                    autofocus
                                                    return-object
                                                    @input="setAutoCompleteEvent('input')"
                                                    @focus="setAutoCompleteEvent('focus')"
                                                    />
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <div class="form-group">
                                            <label>دسته بندی اقلام ورودی</label>
                                            <v-autocomplete
                                                    v-model="editedItem.input_category_id"
                                                    :items="inputCategories"
                                                    :item-text="(item)=>{return item.name}"
                                                    :item-value="(item)=>{return item.category_id}"
                                                    dense
                                            />
                                            <label class="text-danger" v-if="!validations.input_category_id.isValid">{{validations.input_category_id.error}}</label>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <div class="form-group">
                                          <CInput
                                              label="شناسه شخص"
                                              v-model="editedItem.contact_id"
                                              :is-valid="validations.contact_id.isValid"
                                              :invalid-feedback="validations.contact_id.error"
                                          />
                                          <contact-searcher v-model="editedItem.contact_id"></contact-searcher>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <CInput
                                                label="تعداد"
                                                v-model="editedItem.qty"
                                                @keypress="isNumber($event)"
                                                :is-valid="validations.qty.isValid"
                                                :invalid-feedback="validations.qty.error"
                                        />
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <div class="form-group">
                                            <label>قیمت هر واحد</label>
                                            <money v-model="editedItem.unit_price" v-bind="money" dir="ltr"
                                                   class="form-control"/>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <CInput
                                                label="شناسه فاکتور خرید"
                                                v-model="editedItem.bill_id"
                                                @keypress="isNumber($event)"
                                                :is-valid="validations.bill_id.isValid"
                                                :invalid-feedback="validations.bill_id.error"
                                        />
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <CInput
                                                label="شناسه فاکتور فروش"
                                                v-model="editedItem.invoice_id"
                                                @keypress="isNumber($event)"
                                                :is-valid="validations.invoice_id.isValid"
                                                :invalid-feedback="validations.invoice_id.error"
                                        />
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <CInput
                                                label="توضیحات"
                                                v-model="editedItem.description"
                                        />
                                    </v-flex>                                    
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <CButton color="danger" class="mb-2 ml-2 text-white"
                                     @click="close">
                                انصراف
                                <CIcon :content="$options.iconsSet.cilBan"/>
                            </CButton>
                            <CButton color="primary" class="mb-2 ml-2 text-white"
                                     @click="save">
                                ذخیره
                                <CIcon :content="$options.iconsSet.cilSave"/>
                            </CButton>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="barCodeDialog" max-width="500px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">اطلاعات بارکد</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md v-for="(item,index) in barCodes" :key="index">
                                <h4>{{item.name}}</h4>
                                <v-divider/>
                                <v-layout wrap>
                                    <v-flex xs12 sm6 md6 v-for="(barCodeItem,itemIndex) in item.list" :key="itemIndex">
                                        <CInput
                                                v-model="barCodeItem.barcode"
                                                :label="'بارکد آیتم ' + (itemIndex+1)"
                                        />
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <CButton color="danger" class="mb-2 ml-2 text-white"
                                     @click="closeBarcodeDialog">
                                انصراف
                                <CIcon :content="$options.iconsSet.cilBan"/>
                            </CButton>
                            <CButton color="primary" class="mb-2 ml-2 text-white"
                                     @click="saveBarcodeDialog">
                                ذخیره
                                <CIcon :content="$options.iconsSet.cilSave"/>
                            </CButton>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="logDialog" max-width="700px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">تاریخچه</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm12 md12>
                                        <v-data-table
                                                :headers="logsHeaders"
                                                :items="selectedItemLogs"
                                                sort-by="log_id"
                                                :hide-default-footer="true"
                                                :disable-pagination="true"
                                                class="elevation-1">
                                            <template v-slot:item="{item}">
                                                <tr>
                                                    <td>{{ item.log_id }}</td>
                                                    <td>{{ item.action }}</td>
                                                    <td>{{ item.user_fullname }}</td>
                                                    <td>{{ convertDateToJDate(item.set_date) }}</td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <CButton color="danger" class="mb-2 ml-2 text-white"
                                     @click="logDialog = false">
                                بستن
                                <CIcon :content="$options.iconsSet.cilBan"/>
                            </CButton>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>
            <CCard>
                <CCardHeader @click="collapse = !collapse">
                    <CIcon name="cil-justify-center"/>
                    <strong> فیلتر </strong>
                </CCardHeader>
                <CCollapse :show="collapse" :duration="400">
                    <CCardBody>
                        <CRow>
                            <CCol sm="3">
                                <CInput
                                        label="شناسه آیتم"
                                        v-model="filters.input_id"
                                />
                            </CCol>
                            <CCol sm="3">
                                <CInput
                                        label="مدل کالا"
                                        v-model="filters.product_name"
                                />
                            </CCol>
                            <CCol sm="3">
                                <label>دسته بندی اقلام ورودی</label>
                                <select class="form-control" v-model="filters.input_category_id">
                                    <option v-bind:value="category.category_id"
                                            v-bind:key="category.category_id"
                                            v-for="category in inputCategories">{{category.name}}
                                    </option>
                                </select>
                            </CCol>
                            <CCol sm="3">
                                <CInput
                                        label="شناسه فاکتور خرید"
                                        v-model="filters.bill_id"
                                />
                            </CCol>   
                            <CCol sm="3">
                                <CInput
                                        label="شناسه فاکتور فروش"
                                        v-model="filters.invoice_id"
                                />
                            </CCol>
                            <CCol sm="3">
                              <label>کاربر مدیریت</label>
                              <select class="form-control" v-model="filters.user_id">
                                <option v-bind:value="user.user_id"
                                        v-bind:key="user.user_id"
                                        v-for="user in users">
                                  {{user.name}}
                                </option>
                              </select>
                            </CCol>
                            <CCol sm="2">
                              <div class="form-group">
                                <label>تاریخ تغییر توسط کاربر مدیریت</label>
                                <date-picker v-model="filters.log_date"
                                             input-format="YYYY-MM-DD HH:mm:ss"
                                             locale="fa" format="YYYY-MM-DD"
                                             display-format="jYYYY-jMM-jDD">
                                </date-picker>
                              </div>
                            </CCol>
                        </CRow>
                    </CCardBody>
                    <CCardFooter class="text-left">
                        <CButton size="sm" color="primary" class="text-white" @click="applyFilters">
                            <CIcon name="cil-check-circle"/>
                            اعمال
                        </CButton>
                        <CButton size="sm" color="danger" class="text-white mr-1" @click="resetFilters">
                            <CIcon name="cil-ban"/>
                            حذف فیلتر ها
                        </CButton>
                    </CCardFooter>
                </CCollapse>
            </CCard>
            <CRow class="text-left" dir="ltr">
                <CButton color="dark" class="mb-2 ml-2 text-white"
                         v-c-tooltip="'خروجی بصورت فایل PDF'"
                         @click="refreshInputs('pdf')">
                    <CIcon :content="$options.iconsSet.cilFilePdf"/>
                </CButton>
                <CButton color="dark" class="mb-2 ml-2 text-white"
                         v-c-tooltip="'خروجی بصورت فایل اکسل'"
                         @click="refreshInputs('excel')">
                    <CIcon :content="$options.iconsSet.cilFileExcel"/>
                </CButton>
            </CRow>
            <v-data-table
                    :headers="headers"
                    :items="inputs"
                    :options.sync="options"
                    :server-items-length="inputsCount"
                    :footer-props="{
                                'items-per-page-options': [100,25, 50]
                    }"
                    sort-by="input_id"
                    sort-desc
                    class="elevation-1">
                <template v-slot:item="{item}">
                    <tr>
                        <td>{{ item.input_id }}</td>
                        <td >{{ item.model }}</td>
                        <td>{{ item.product_name }}</td>
                        <td>{{ getObjectNameById(inputCategories,'category_id',item.input_category_id) }}</td>
                        <td>{{ item.bill_id }}</td>
                        <td>{{ item.invoice_id }}</td>
                        <td>{{ item.qty }}</td>
                        <td>{{ item.unit_price | currency(' ریال', 0, { symbolOnLeft: false }) }}</td>
                        <td style="width: 150px;">
                            <v-icon medium
                                    v-c-tooltip="'بارکد'"
                                    class="mr-2"
                                    @click="showBarCodeDialog(item)">
                                mdi-barcode
                            </v-icon>
                            <v-icon
                                    medium
                                    v-c-tooltip="'ویرایش'"                                    
                                    class="mr-2"
                                    @click="editItem(item,false)">
                                mdi-pencil
                            </v-icon>
                            <v-icon
                                    medium
                                    v-c-tooltip="'حذف'"                                    
                                    @click="deleteInputs(item)">
                                mdi-delete
                            </v-icon>
                            <v-icon
                                    medium
                                    v-c-tooltip="'نمایش تاریخچه'"                                    
                                    @click="showLogDialog(item)">
                                mdi-information
                            </v-icon>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </CCardBody>
    </CCard>
</template>

<script>
    import {
      getFunction,
      functionAction,
      productAutoComplete,
      getCategoryType
    } from '../../webservice/webservice';
    import {iconsSet} from '../../assets/icons/icons'
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
    import moment from "moment-jalaali";    

    export default {
        name: 'Inputs',
        props: {},
        iconsSet,
        components: {
          datePicker: VuePersianDatetimePicker
        },
        methods: {
          getObjectNameById(list, key, id, extraKey) {
            for (let i = 0; i < list.length; i++) {
              if (list[i][key] === id) {
                if (extraKey) {
                  return list[i].name + ' ' + list[i][extraKey]
                }
                return list[i].name
              }
            }
          },
            isNumber: function (evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode < 48 || charCode > 57)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            addItem() {
                this.editedItem = {
                    "input_id": "",
                    "bill_id": "",
                    "invoice_id": "",
                    "product_option_id": "",
                    "unit_price": "",
                    "input_category_id": "",
                    "contact_id": "",
                    "description": "",
                    "qty": ""
                };
                this.editItemText = true;
                this.dialog = true
            },
            editItem(item) {
                this.editedIndex = this.inputs.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.editItemText = false;
                this.dialog = true
            },
            close() {
                this.dialog = false;
                Object.keys(this.validations).map((k) => {
                    this.validations[k] = {isValid: null, error: ''}
                });
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                })
            },
            save() {
                Object.keys(this.validations).map((key) => {
                    this.validations[key].error = '';
                    this.validations[key].isValid = null;
                });
                let action = this.editedIndex === -1 ? 'add' : 'update';
                if (this.editedItem.invoice_id === null) {
                    this.editedItem.invoice_id = ''
                }
                if (this.editedItem.product_option_id.product_option_id) {
                    this.editedItem.product_option_id = this.editedItem.product_option_id.product_option_id;
                }
                this.editedItem.unit_price = this.editedItem.unit_price.toString();
                functionAction(this.$http, 'inputs', action, this.editedItem).then((resp) => {
                    if (resp.success) {
                        this.$toasted.show(resp.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                        this.refreshInputs();
                        this.close()
                    } else {
                        let errors = resp.body.errors;
                        Object.keys(errors).map((k) => {
                            this.validations[k] = {isValid: false, error: errors[k]}
                        });
                        this.$toasted.show(resp.body.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });

                    }
                });
            },
            applyFilters() {
                let filters = Object.assign({}, this.filters);
                Object.keys(filters).forEach(function (key) {
                    if (filters[key] === '' || filters[key] === 0) {
                        delete filters[key]
                    } else {
                        filters[key] = `${filters[key]}`;
                    }
                });
                this.refreshInputs();
                this.filteredReq = filters;
            },
            resetFilters() {
                this.filters = {};
                this.refreshInputs();
                this.filteredReq = {}
            },
            deleteInputs(item) {
                var r = confirm("آیا مطمین هستید؟");
                if (r == true) {                    
                    Object.keys(item).map((key) => {
                        if (item[key] === null) {
                            item[key] = ''
                        }
                    });
                    item.invoice_id = '';
                    if (item.bill_id === null) {
                        item.bill_id = ''
                    }
                    functionAction(this.$http, 'inputs', 'delete', item).then((resp) => {
                        if (resp.success) {
                            this.$toasted.show(resp.message, {
                                theme: "toasted-primary",
                                position: "bottom-center",
                                duration: 3000
                            });
                            this.refreshInputs();
                        } else {
                            this.$toasted.show("اطلاعات ارسالی اشتباه است.", {
                                theme: "toasted-danger",
                                position: "bottom-center",
                                duration: 5000
                            });
                        }
                    });
                }
            },
            refreshInputs(fileType) {
                let filters = Object.assign({}, this.filters);
                Object.keys(filters).forEach(function (key) {
                    if (filters[key] === '' || filters[key] === 0) {
                        delete filters[key]
                    } else {
                        filters[key] = `${filters[key]}`;
                    }
                });
                getFunction(this.$http, 'inputs', (this.tableOption.itemsPerPage * (this.tableOption.page -1)),
                    100, this.tableOption.sortedField, this.tableOption.sortDesc ? 'desc' : 'asc', filters, fileType).then((resp) => {
                        if (fileType !== undefined) {
                            if (fileType === 'pdf') {
                                window.open(resp.fileurl, '_blank');
                                return;
                            }
                            const link = document.createElement('a');
                            link.href = resp.fileurl;
                            link.setAttribute('download', 'outputs.' + ((fileType === 'pdf') ? 'pdf' : 'xls'));
                            document.body.appendChild(link);
                            link.click()
                        } else {
                            this.inputs = resp.list;
                            this.inputsCount = resp.count
                        }
                    }
                )
                ;
                this.filteredReq = filters;
            },
            showBarCodeDialog(item) {
                this.barCodes = [];
                getFunction(this.$http, 'input_barcodes', 0, 10000, 'name', 'desc', {"input_id": item.input_id}).then((resp) => {
                    this.barCodes.push({
                        name: item.product_name,
                        id: item.input_id,
                        list: resp.list
                    });
                    this.barCodeDialog = true;
                });
            },
            closeBarcodeDialog() {
                this.barCodeDialog = false;
                this.barCodes = []
            },
            saveBarcodeDialog() {
                this.barCodes.map((obj) => {
                    functionAction(this.$http, 'input_barcodes', 'add', obj.list, true).then((resp) => {
                        if (resp.success) {
                            this.barCodeDialog = false;
                            this.barCodes = []
                        }
                        this.$toasted.show(resp.body.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 5000
                        });
                    });
                });

            },
            showLogDialog(item) {
                this.logDialog = true;
                getFunction(this.$http, 'logs', 0, 1000, 'name', 'desc', {
                    "code": "input",
                    "code_id": item.input_id
                }).then((resp) => {
                    this.selectedItemLogs = resp.list
                })
            },
            setAutoCompleteEvent(eventName){
                console.log(eventName);
                if(eventName == 'input'){
                    this.productAutoEnable = false;
                }else if(eventName == 'focus'){
                    this.productAutoEnable = true;
                }

            }, convertDateToJDate(dt) {
                let convertedDate = moment(dt, 'YYYY-MM-DD HH:mm:ss').format('jYYYY/jM/jD HH:mm:ss');
                if (convertedDate === 'Invalid date') {
                    return 'نامعلوم'
                }
                return convertedDate
            },
        },
        data: () => {
            return {
                dialog: false,
                headers: [
                    {text: 'شماره آیتم', value: 'input_id'},
                    {text: 'مدل', value: 'model'},
                    {text: 'نام آیتم', value: 'product_option_id'},
                    {text: 'دسته بندی', value: 'input_category_id'},
                    {text: 'شناسه فاکتور خرید', value: 'bill_id'},
                    {text: 'شناسه فاکتور فروش', value: 'invoice_id'},
                    {text: 'تعداد', value: 'qty'},
                    {text: 'قیمت هر واحد', value: 'unit_price'},
                    {text: 'عملیات', sortable: false}
                ],
                logsHeaders: [
                    {text: 'شناسه', value: 'log_id'},
                    {text: 'عملیات', value: 'action'},
                    {text: 'کاربر', value: 'user_fullname'},
                    {text: 'زمان', value: 'set_date'}
                ],
                inputs: [],
                inputsCount: 0,
                editedIndex: -1,
                editedItem: {
                    "input_id": "",
                    "bill_id": "",
                    "invoice_id": "",
                    "product_option_id": "",
                    "unit_price": "",
                    "input_category_id": "",
                    "contact_id": "",
                    "description": "",
                    "qty": ""
                },
                options: {},
                collapse: false,
                filters: {},
                validations: {
                    qty: {isValid: null, error: ''},
                    bill_id: {isValid: null, error: ''},
                    input_category_id: {isValid: null, error: ''},
                    invoice_id: {isValid: null, error: ''},
                    contact_id: {isValid: null, error: ''}
                },
                tableOption: {
                    sortDesc: true,
                    sortedField: 'name',
                    itemsPerPage: 10,
                    page: 1
                },
                filteredReq: {},
                productSearch: '',
                productAutoLoading: false,
                productAutoEnable:true,
                productsList: [],
                inputCategories: [],
                contacts: [{
                    name: "هیچکدام",
                    family: '',
                    contact_id: ''
                }],
                users: [],
                money: {
                    decimal: '',
                    thousands: ',',
                    prefix: '',
                    suffix: '',
                    precision: 0,
                    masked: false
                },
                barCodeDialog: false,
                barCodeItem: {qty: 0},
                barCodes: [],
                editItemText: true,
                logDialog: false,
                selectedItemLogs: []
            }
        },
        mounted() {

            if (this.$route.params.id) {
              if(this.$route.params.id.startsWith("model"))
                this.filteredReq = this.filters = {product_name: this.$route.params.id.replace("model", "")};
              else if(this.$route.params.id.startsWith("a"))
                this.filteredReq = this.filters = { input_id: this.$route.params.id.replace("a", "") };
              else
                  this.filteredReq = this.filters = {bill_id: this.$route.params.id};
            }
            getCategoryType(this.$http, 1).then((resp) => {
                this.inputCategories = resp.list;
                getFunction(this.$http, 'user', 0, 1000, 'name', 'desc', {}).then((resp) => {
                    this.users = this.users.concat(resp.list);
                });
            });
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'آیتم جدید' : 'ویرایش آیتم'
            }

        },
        watch: {
            dialog(val) {
                val || this.close()
            },
            options: {
                handler(value) {
                    console.log(value);
                    this.tableOption.sortedField = value['sortBy'][0];
                    this.tableOption.sortDesc = value['sortDesc'][0];
                    this.tableOption.itemsPerPage = value.itemsPerPage;
                    this.tableOption.page = value.page;
                    getFunction(this.$http, 'inputs', (value.itemsPerPage * (value.page -1)),
                        value.itemsPerPage,
                        value['sortBy'][0],
                        value['sortDesc'][0] ? 'desc' : 'asc',
                        this.filteredReq).then((resp) => {
                        this.inputs = resp.list;
                        this.inputsCount = resp.count
                    });
                },
                deep: true,
            },
            productSearch(val) {
                if(this.productAutoEnable){
                    let filter = {"name": `%${val}%`};
                    this.productAutoLoading = true;
                    productAutoComplete(this.$http, 0, 1000, 'name', 'desc', filter).then((resp) => {
                        this.productsList = resp.list;
                    }).finally(() => (this.productAutoLoading = false));
                }
            },
        },
    }
</script>
